// import React, { useState, useRef, useEffect } from "react";
// import ReactQuill, { Quill } from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import "./index.scss";
// import imageResize from "quill-image-resize-module-zzone";
// import { MyCustomUploadAdapterPlugin } from "./MyCustomUploadAdapterPlugin";

// const Size = Quill.import("attributors/style/size");
// Size.whitelist = [
//   "12px",
//   "14px",
//   "16px",
//   "18px",
//   "20px",
//   "24px",
//   "30px",
//   "36px",
// ];
// Quill.register(Size, true);
// Quill.register("modules/imageResize", imageResize);

// const MyRichTextEditor = ({ value, onChange, ...props }) => {
//   const reactQuillRef = useRef(null);
//   const [editorContent, setEditorContent] = useState(value || "");
//   const isFirstRender = useRef(true);
//   useEffect(() => {
//     if (reactQuillRef.current) {
//       const quill = reactQuillRef.current.getEditor();
//       MyCustomUploadAdapterPlugin(quill);
//     }
//   }, []);
//   useEffect(() => {
//     if (isFirstRender.current) {
//       isFirstRender.current = false;
//       return;
//     }

//     if (value !== editorContent) {
//       setEditorContent(value);
//     }
//   }, [value]);
//   const handleChange = (content, delta, source, editor) => {
//     setEditorContent(content);
//     if (onChange) {
//       // 可以选择传递 HTML 内容或者 getText()
//       onChange(content);
//     }
//   };

//   const modules = {
//     toolbar: {
//       container: [
//         [{ header: [1, 2, 3, 4, 5, 6, false] }],
//         [
//           {
//             size: [
//               "12px",
//               "14px",
//               "16px",
//               "18px",
//               "20px",
//               "24px",
//               "30px",
//               "36px",
//             ],
//           },
//         ],
//         [
//           {
//             font: ["SimSun", "SimHei", "Microsoft-YaHei", "KaiTi", "FangSong"],
//           },
//         ],
//         ["bold", "italic", "underline", "strike"],
//         [{ color: [] }, { background: [] }],
//         [{ lineheight: ["1", "1.5", "1.75", "2", "3", "4", "5"] }],
//         [{ align: [] }],
//         [
//           { list: "ordered" },
//           { list: "bullet" },
//           { indent: "-1" },
//           { indent: "+1" },
//         ],
//         ["link", "image"],
//         ["blockquote", "code-block"],
//         [{ script: "sub" }, { script: "super" }],
//         ["clean"],
//       ],
//     },
//     imageResize: {
//       displayStyles: {
//         backgroundColor: "black",
//         border: "none",
//         color: "white",
//       },
//       modules: ["Resize", "DisplaySize", "Toolbar"],
//     },
//     clipboard: {
//       matchVisual: false,
//     },
//   };

//   const formats = [
//     "header",
//     "size",
//     "font",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "color",
//     "background",
//     "lineheight",
//     "align",
//     "list",
//     "bullet",
//     "link",
//     "image",
//     "blockquote",
//     "code-block",
//     "script",
//     "indent",
//   ];

//   return (
//     <div className="rich-text-editor">
//       <ReactQuill
//         ref={reactQuillRef}
//         value={editorContent}
//         onChange={handleChange}
//         modules={modules}
//         formats={formats}
//         theme="snow"
//         {...props}
//       />
//     </div>
//   );
// };

// export default MyRichTextEditor;
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import axiosInstance from "@/axios/axiosInstance";
import React, { useState, useEffect } from "react";
import { Editor, Toolbar } from "@wangeditor/editor-for-react";
import { DomEditor } from "@wangeditor/editor";

const MyRichTextEditor = ({ value, onChange, ...props }) => {
  // editor 实例
  const [editor, setEditor] = useState(null);

  // 编辑器内容
  const [html, setHtml] = useState("");

  useEffect(() => {
    if (value !== html) {
      setHtml(value);
    }
  }, [value]);
  // 工具栏配置
  const toolbarConfig = {};

  // 编辑器配置
  const editorConfig = {
    placeholder: "请输入内容...",
    autoFocus: false,
    MENU_CONF: {
      uploadImage: {
        server: "/sys/image/file",
        // 自定义上传函数
        customUpload(file, insertFn) {
          // 创建 FormData
          const formData = new FormData();
          formData.append("file", file);
          formData.append("type", 2);

          // 使用 axiosInstance 发送请求
          axiosInstance
            .post("/sys/image/file", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 10000) {
                // 插入图片到编辑器
                insertFn(response.data.data.imageUrl);
              } else {
                console.error("上传失败:", response.message);
              }
            })
            .catch((error) => {
              console.error("上传出错:", error);
            });
        },
        // 单个文件的最大体积限制
        maxFileSize: 10 * 1024 * 1024, // 10MB
        // 最多同时上传几个文件
        maxNumberOfFiles: 10,
        // 选择文件时的类型限制，默认为 ['image/*']
        allowedFileTypes: ["image/*"],
        // 自定义上传错误提示
        onError(file, err, res) {
          console.error(`${file.name} 上传出错:`, err, res);
        },
        // 上传进度条
        onProgress(progress) {
          console.log("上传进度:", progress);
        },
        // 上传成功
        onSuccess(file, res) {
          console.log(`${file.name} 上传成功:`, res);
        },
        // 上传失败
        onFailed(file, res) {
          console.log(`${file.name} 上传失败:`, res);
        },
      },
    },
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);
  const handleChange = (content, delta, source, editor) => {
    setHtml(content.getHtml());
    if (onChange) {
      // 可以选择传递 HTML 内容或者 getText()
      onChange(content.getHtml());
    }
  };
  return (
    <>
      <div style={{ border: "1px solid #ccc", zIndex: 100 }}>
        <Toolbar
          editor={editor}
          defaultConfig={toolbarConfig}
          mode="default"
          style={{ borderBottom: "1px solid #ccc" }}
        />
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={(editor) => handleChange(editor)}
          mode="default"
          style={{ height: "500px", overflowY: "hidden" }}
        />
      </div>
    </>
  );
};

export default MyRichTextEditor;
